import { Controller } from '@hotwired/stimulus'
import { render, h } from 'preact'
import { QuotaMeter } from '../components/shared/quota/QuotaMeter.jsx'
import { I18n } from 'i18n-js'
import locales from '../locales.json'

/** Mounts Preact QuotaMeter rows for subscription / admin usage summaries. */
export default class extends Controller {
  static values = {
    meters: { type: Array, default: [] },
    highlight: { type: String, default: '' }
  }

  connect() {
    this.i18n = new I18n(locales)
    this.i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'
    this._renderMeters()
  }

  disconnect() {
    render(null, this.element)
  }

  metersValueChanged() {
    if (this.i18n) this._renderMeters()
  }

  _renderMeters() {
    const meters = this.metersValue || []
    const highlight = this.highlightValue
    render(
      h(
        'div',
        { class: 'vstack gap-3' },
        meters.map((quota) => {
          const metric = quota.metric || quota.code
          const upgrades = quota.upgrades || []
          const highlighted = highlight && upgrades.some(
            (u) => (u.product_code || u.productCode) === highlight
          )
          return h('div', {
            key: metric,
            class: highlighted ? 'subscription-quota-highlight p-2 rounded border border-primary' : ''
          }, h(QuotaMeter, { quota, t: (key, opts) => this.i18n.t(key, opts) }))
        })
      ),
      this.element
    )
  }
}
